import {Exclude, Expose, instanceToPlain, plainToInstance} from "class-transformer";
import * as t from "io-ts";
import {validateJSON, validateJSONNow} from "../web/validation";
import {Entity} from "./entity";

export const ContainerClusterValidator = t.intersection([
  t.type({
    id: t.string,
    name: t.string,
    equalized: t.boolean,
    siteId: t.string,
    regionId: t.string,
  }),
  t.partial({
    afe: t.string,
    afePrefix: t.string,
    afeSuffix: t.string,
    leaseId: t.string,
    leaseName: t.string,
    siteName: t.string,
    createDttm: t.number,
    lastModifiedDttm: t.number,
  }),
]);

export const ContainerClusterArrayValidator = t.array(
  ContainerClusterValidator
);

export type ContainerCluster = t.TypeOf<typeof ContainerClusterValidator>;
export type ContainerClusterArray = t.TypeOf<typeof ContainerClusterArrayValidator>;

@Exclude()
export class ContainerClusterEntity implements Entity {
  @Expose()
  id!: string;

  @Expose()
  name!: string;

  @Expose()
  equalized!: boolean

  @Expose()
  afe?: string

  @Expose()
  afePrefix?: string

  @Expose()
  afeSuffix?: string

  @Expose()
  leaseId?: string

  @Expose()
  leaseName?: string

  @Expose()
  siteId!: string;

  @Expose()
  siteName?: string;

  @Expose()
  regionId!: string;

  @Expose()
  createDttm?: number;

  @Expose()
  lastModifiedDttm?: number;

  readonly entityType = 'CONCOMMIGLED';

  get displayName(): Readonly<string> {
    return this.name;
  }

  /**
   * Constructor for ContainerClustgerEntity. Recommend using the {@link create} method instead.
   * @hideconstructor
   */
  constructor() {
    // Empty constructor for 'class-transformer'
  }

  static from(value: ContainerCluster): ContainerClusterEntity {
    return plainToInstance(ContainerClusterEntity, value, {
      excludeExtraneousValues: true,
    });
  }

  loadTypeValue(): Promise<ContainerCluster> {
    const object = instanceToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSON(ContainerClusterValidator, object);
  }

  asTypeValue(): ContainerCluster {
    const object = instanceToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSONNow(ContainerClusterValidator, object);
  }
}
